import { filters } from './../../shared/models/listRelatedRequest';
import { CommonService } from './common.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpointsURL } from 'src/app/constants/endpointsURL';
import { environment } from 'src/environments/environment';
import { ToastrAlertService } from './toastrAlert.service';
import { SweetAlertService } from './sweet-alert.service';

@Injectable({
  providedIn: 'root',
})
export class ExportarExcelMassivoService {
    
    private env = environment.env;
    private certificatesURL = endpointsURL.certificatesURL;
    private cocURL = endpointsURL.cocMailBoxURL;
    private placaURL = endpointsURL.placaURL;

    constructor(private http: HttpClient, private sweetAlertService: SweetAlertService, private toastrAlertService: ToastrAlertService, private commonService: CommonService) {}

    /**
     * Exporta un Excel masivo desde la API.
     */
    exportToExcel(tipo: string, filters: Record<string, any>) {
        this.sweetAlertService.sweetAlertLoading();
        let url = '';
        let exportacionId: number;

        if (tipo === 'coc') 
        {
            url = `${this.env}${this.cocURL}consulta/iniciarExportacion`;
        } 
        else if (tipo === 'placa') 
        {
            url = `${this.env}${this.placaURL}consulta/iniciarExportacion`;
        } 
        else if (tipo === 'certificado') 
        {
            url = `${this.env}${this.certificatesURL}consulta/iniciarExportacion`;
        } 
        else
        {
            throw new Error('Tipo de exportación no válido');
        }

        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                params.append(key, value.toString());
            }
        });

        this.http.post(`${url}?${params.toString()}`, null).subscribe((response: any) => {
            const exportacionId = response.idExportacion;

            if (!exportacionId || isNaN(exportacionId)) {
                throw new Error('El exportacionId recibido no es válido');
            }

            this.verificarEstadoExportacion(tipo, exportacionId);
        });
    }

    private verificarEstadoExportacion(tipo: string, exportacionId: number) 
    {
        let estadoUrl = '';

        if (tipo === 'coc')
        {
            estadoUrl = `${this.env}${this.cocURL}consulta/estadoExportacion`;
        } 
        else if (tipo === 'placa') 
        {
            estadoUrl = `${this.env}${this.placaURL}consulta/estadoExportacion`;
        } 
        else if (tipo === 'certificado') 
        {
            estadoUrl = `${this.env}${this.certificatesURL}consulta/estadoExportacion`;
        }

        // Función para verificar el estado
        const verificar = () => {
            this.http.get(`${estadoUrl}?exportacionId=${exportacionId}`).subscribe(
                (response: any) => {
                    const estado = response.estado;

                    if (estado === 'ID_ERRONEO') 
                    {
                        clearInterval(interval);
                        this.toastrAlertService.toastrFail('Error:', response.mensaje);
                    } 
                    else if (estado === 'EN_PROCESO') 
                    {
                        this.toastrAlertService.toastrInfo(response.mensaje);
                    } 
                    else if (estado === 'FINALIZADO') 
                    {
                        clearInterval(interval);
                        this.toastrAlertService.toastrSuccess(response.mensaje);
                        const blobData = response.blob;
                        const blob = this.base64ToBlob(blobData, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        const today = new Date();
                        const formattedDate = `${today.getDate().toString().padStart(2, '0')}${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getFullYear().toString().slice(-2)}`;
                        this.commonService.downloadFile(blob, `Exportacion${tipo.toUpperCase()}_${formattedDate}.xlsx`);
                    }
                    this.sweetAlertService.sweetAlertClose();
                },
                (error) => {
                    clearInterval(interval);
                    this.sweetAlertService.sweetAlertClose();
                    this.toastrAlertService.toastrFail(error.mensaje);
                }
            );
        };

        // Llama a la función inmediatamente
        verificar();

        // Configura el intervalo para las siguientes verificaciones
        const interval = setInterval(verificar, 10000);
    }

    /**
     * Convierte una cadena Base64 a un Blob.
     */
    private base64ToBlob(base64: string, contentType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
}